import { ShiftType } from '@lmc/ts-common'
import { useQuery } from 'react-query'
import { SHIFT_TYPES_QUERY_KEY, SHIFT_TYPES_URL } from './queryConstants'
import { getJSON } from 'common/services/api'

export type ShiftFormType = {
  types: ShiftType[]
}

type UseShiftTypesListReturn = {
  shiftTypes: ShiftType[]
  isShiftTypesLoading: boolean
  refetch: () => void
}

export const useShiftTypesList = (): UseShiftTypesListReturn => {
  const {
    data: shiftTypes,
    isLoading,
    refetch,
  } = useQuery(
    [SHIFT_TYPES_QUERY_KEY] as string[],
    () =>
      getJSON({
        url: SHIFT_TYPES_URL,
        isRota: true,
      }),
    { enabled: true }
  )

  return {
    shiftTypes: shiftTypes?.data,
    isShiftTypesLoading: isLoading,
    refetch,
  }
}
